module.exports = __webpack_public_path__ + "static/img/loading.2f68d11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/goodsPushPage/img/loading.gif
// module id = DjSu
// module chunks = 1